let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("48xap")).then(() => parcelRequire('8K4bZ'));